import axios from '@/core/http'

const sendXPathRequest = ({ url, xpath }) => {
  return axios.post('spiders/xpath-request/', { url, xpath })
}

export { sendXPathRequest }
